const ZOOM_LEVEL_MAP:{[key:string]: number} = {
  573: 3,
  565: 5,
  566: 7,
  574: 9,
  567: 11,
  568: 13,
  575: 15,
  569: 17,
  901: 21
}

export const redirectToErrorPage = function() {
  window.location.href = `/error`;
}

export const parseZoomLevel = function(level:number|string) {
  return ZOOM_LEVEL_MAP[level];
}

export const getParamFromUrl = function(name:string) {
  const paramsStr = window.location.search.replace(/^\?/, '');
  const params = paramsStr.split('&');
  return ((items) => {
    const paramsMap:{ [key: string] : any } = {}
    for ( const item of items) {
      const [key, value] = item.split('=');
      paramsMap[key] = value;
    }
    return paramsMap;
  })(params)[name]
}

export const camelize = function(str:string) {
  return str.split('_').map(function(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
}

export const wrappedPromise = function() {
  const wrappedPromise:any = {},
      promise = new Promise(function (resolve, reject) {
          wrappedPromise.resolve = resolve;
          wrappedPromise.reject = reject;
      });
  wrappedPromise.then = promise.then.bind(promise);
  wrappedPromise.catch = promise.catch.bind(promise);
  wrappedPromise.promise = promise;

  return wrappedPromise;
}

/**
 * Compares two path arrays of LatLng objects.
 */

export const arePathsEqual = function(pathA:Array<any>, pathB:Array<any>) {
  if (pathA === pathB) {
    return true;
  }
  if (!Array.isArray(pathA) || !Array.isArray(pathB)) {
    return false;
  }
  if (pathA.length !== pathB.length) {
    return false;
  }
  for (let i = 0; i < pathA.length; ++i) {
    if (pathA[i] === pathB[i]) {
      continue;
    }
    if (
      !isValidLatLng(pathA[i]) ||
      !isValidLatLng(pathB[i])
    ) {
      return false;
    }
    if (
      pathB[i].lat !== pathA[i].lat ||
      pathB[i].lng !== pathA[i].lng
    ) {
      return false;
    }
  }
  return true;
}

/**
 * Helper that checks whether an array consists of objects
 * with lat and lng properties
 * @param {object} elem the element to check
 * @returns {boolean} whether or not it's valid
 */
const isValidLatLng = function(elem:any) {
  return (
    elem !== null &&
    typeof elem === 'object' &&
    Object.prototype.hasOwnProperty.call(elem, 'lat') &&
    Object.prototype.hasOwnProperty.call(elem, 'lng')
  );
}